"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toastOptions = void 0;
exports.fetchRecords = fetchRecords;
exports.makeReport = makeReport;
exports.login = login;
exports.getUserinfo = getUserinfo;
exports.logout = logout;
exports.getCheckIds = getCheckIds;
exports.modifyOrder = modifyOrder;
exports.modifyResultsRemark = modifyResultsRemark;
exports.modifyResults = modifyResults;
exports.uploadResults = uploadResults;
exports.getProducts = getProducts;
exports.getHospitals = getHospitals;
exports.getLisUrls = getLisUrls;
var react_toastify_1 = require("react-toastify");
exports.toastOptions = {
    position: "top-right",
    hideProgressBar: true,
    theme: "colored",
    transition: react_toastify_1.Flip,
    autoClose: 6000,
    closeButton: true,
};
function fetchRecords(pnum, psize, keyword) {
    return __awaiter(this, void 0, void 0, function () {
        var params, response, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = new URLSearchParams({ pnum: pnum, psize: psize, keyword: keyword });
                    return [4 /*yield*/, fetch("/xdh1-api/orders/search?".concat(params.toString()))];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    console.log(json.data);
                    return [2 /*return*/, json.data];
            }
        });
    });
}
function makeReport(order_id) {
    return __awaiter(this, void 0, void 0, function () {
        var params, response, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = new URLSearchParams({ order_id: order_id });
                    return [4 /*yield*/, fetch("/xdh1-api/report/make?".concat(params.toString()), {
                            method: "POST",
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    console.log(json.data);
                    if (json.message) {
                        react_toastify_1.toast.info(json.message, exports.toastOptions);
                    }
                    return [2 /*return*/, json.data];
            }
        });
    });
}
function login(username, password) {
    return __awaiter(this, void 0, void 0, function () {
        var response, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("/auth/login", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ username: username, password: password }),
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    console.log(json.data);
                    if (json.code && json.message) {
                        react_toastify_1.toast.error(json.message, exports.toastOptions);
                    }
                    return [2 /*return*/, json.data];
            }
        });
    });
}
function getUserinfo() {
    return __awaiter(this, void 0, void 0, function () {
        var response, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("/auth/userinfo")];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    console.log(json.data);
                    return [2 /*return*/, json.data];
            }
        });
    });
}
function logout() {
    return __awaiter(this, void 0, void 0, function () {
        var response, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("/auth/logout")];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    console.log(json.data);
                    if (json.message) {
                        react_toastify_1.toast.info(json.message, exports.toastOptions);
                    }
                    return [2 /*return*/, json.data];
            }
        });
    });
}
function getCheckIds(tjId, hospital) {
    return __awaiter(this, void 0, void 0, function () {
        var payload, response, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = { tj_id: tjId, hospital: hospital };
                    return [4 /*yield*/, fetch("/xdh1-api/order/check_ids", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify(payload),
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    if (json.message) {
                        react_toastify_1.toast.info(json.message, exports.toastOptions);
                    }
                    return [2 /*return*/, json.data];
            }
        });
    });
}
function modifyOrder(partialOrder) {
    return __awaiter(this, void 0, void 0, function () {
        var response, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("/xdh1-api/order/modify", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(partialOrder),
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    console.log(json.data);
                    if (json.message) {
                        react_toastify_1.toast.info(json.message, exports.toastOptions);
                    }
                    return [2 /*return*/, json.data];
            }
        });
    });
}
function modifyResultsRemark(orderId, results) {
    return __awaiter(this, void 0, void 0, function () {
        var payload, response, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = { id: orderId, results: results };
                    return [4 /*yield*/, fetch("/xdh1-api/order/modify-results-remark", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify(payload),
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    console.log(json.data);
                    return [2 /*return*/, json.data];
            }
        });
    });
}
function modifyResults(orderId, results) {
    return __awaiter(this, void 0, void 0, function () {
        var payload, response, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = { id: orderId, results: results };
                    return [4 /*yield*/, fetch("/xdh1-api/order/modify-results", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify(payload),
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    console.log(json.data);
                    if (json.message) {
                        react_toastify_1.toast.info(json.message, exports.toastOptions);
                    }
                    return [2 /*return*/, json.data];
            }
        });
    });
}
function uploadResults(order_id) {
    return __awaiter(this, void 0, void 0, function () {
        var payload, response, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = { id: order_id };
                    return [4 /*yield*/, fetch("/xdh1-api/order/upload-results", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify(payload),
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    console.log(json.data);
                    if (json.message) {
                        react_toastify_1.toast.info(json.message, exports.toastOptions);
                    }
                    return [2 /*return*/, json.data];
            }
        });
    });
}
function getProducts() {
    return __awaiter(this, void 0, void 0, function () {
        var response, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("/xdh1-api/products/search", {
                        method: "GET",
                        headers: { "Content-Type": "application/json" },
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    return [2 /*return*/, json.data];
            }
        });
    });
}
function getHospitals() {
    return __awaiter(this, void 0, void 0, function () {
        var response, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("/xdh1-api/hospitals/search", {
                        method: "GET",
                        headers: { "Content-Type": "application/json" },
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    return [2 /*return*/, json.data];
            }
        });
    });
}
function getLisUrls() {
    return __awaiter(this, void 0, void 0, function () {
        var response, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("/xdh1-api/lis_urls/search", {
                        method: "GET",
                        headers: { "Content-Type": "application/json" },
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    return [2 /*return*/, json.data];
            }
        });
    });
}
